const dropDownBehaviour = {
   dropDownButtons: [],

   init() {
      let self = this;

      let node = document.querySelector('.js-dropdown');

      if(node) {
         self._createListeners(node);
      }
   },


   _createListeners(node) {
      let self = this;

         let nodeButtons = node.querySelectorAll('.js-dropdown__button');
         nodeButtons.forEach((nodeButton)=> {

            if(nodeButton.dataset.initialized === 'true') {
               return;
            }

            nodeButton.addEventListener('click', self._toggleDropDown, null);
            nodeButton.dataset.initialized = "true";
         });
   },

   _toggleDropDown() {
      this.closest('.js-dropdown__item').classList.toggle('js-dropdown__item--active');
   },
};

dropDownBehaviour.init();

document.addEventListener('LokiRequestEnd', function () {
   dropDownBehaviour.init();
});
